import React, { Component } from 'react';
import { connect } from "react-redux";
import { Container, Col, Row, Table, Button, InputGroup, InputGroupAddon, Input, Label } from 'reactstrap';
import MaterialIcon from "material-icons-react";
import i18n from "../../../../i18next";

import { loadRestaurantSettings, loadTaxSettings, saveTaxSettings, saveTaxSettingsPixelPoint } from "../../../../actions";
import { convertStringToBoolean, convertStringToNumber } from "../../../../utils/CommonUtils";
import { US, CA } from '../../../../utils/Constants';

const INITIAL_STATE = {
    taxSettings: {
        taxBands: [],
        taxIncludedInPrice: false,
        taxPostDiscount: false,
        taxableDeliveryCharge: false
    },
    stateAlreadyCopiedFromProps: false
};

class TaxesScreen extends Component {

    constructor(props) {
        super(props);

        this.state = {
            taxSettings: {
                taxBands: [],
                taxIncludedInPrice: false,
                taxPostDiscount: false,
                taxableDeliveryCharge: false,
                country: null
            },
            stateAlreadyCopiedFromProps: false
        }

        this.changeTaxBandsState = this.changeTaxBandsState.bind(this);
        this.changeConditionalAttributeState = this.changeConditionalAttributeState.bind(this);
        this.saveTaxSettings = this.saveTaxSettings.bind(this);
    }

    componentWillMount() {
        const { id } = this.props.match.params;

        this.props.loadTaxSettings(id);
        this.props.loadRestaurantSettings(id);
    }

    componentWillUnmount() {
        this.state = INITIAL_STATE;
    }

    copyStateFromProps() {
        const { taxSettings, posSettings } = this.props;
        if (taxSettings !== undefined && taxSettings !== null && posSettings !== undefined && posSettings !== null && posSettings.length !== 0 && !this.state.stateAlreadyCopiedFromProps) {

            // Load all taxBands for pixelPoint
            const posIsPixelPoint = (posSettings.type && posSettings.type.id === 5) && posSettings.type.value === "Par Pixelpoint";

            let taxBands = this.copyTaxBands();
            if (posIsPixelPoint) taxBands = this.copyTaxBandsPixelPoint();

            const taxSettingsCopyFromProps = {
                taxBands: taxBands,
                taxIncludedInPrice: taxSettings.taxIncludedInPrice,
                taxPostDiscount: taxSettings.taxPostDiscount,
                taxableDeliveryCharge: taxSettings.taxableDeliveryCharge
            };

            this.setState({
                taxSettings: taxSettingsCopyFromProps,
                stateAlreadyCopiedFromProps: true
            });
        }
    }

    componentWillReceiveProps(nextProps) {
        // TODO VT if something with saving or caching the data for the settings is not working properly remove the code with componentWillUnmount componentWillMount
        if (nextProps.taxSettings && this.props.taxSettings) {
            // If we have updated data for the taxBands force component mount to show the correct data
            if (JSON.stringify(nextProps.taxSettings.taxBands) !== JSON.stringify(this.props.taxSettings.taxBands)) {
                this.componentWillUnmount();
                this.componentWillMount();
            }
        }
    }

    copyTaxBands() {
        const { taxSettings } = this.props;
        const taxBands = [];

        for (let i = 0; i < 4; i++) {
            let taxBand = taxSettings.taxBands[i];
            if (taxBand === undefined || taxBand === null || taxBand.taxPercent === null || taxBand.taxPercent < 0) {
                taxBand = {
                    id: (-1 * i),
                    taxPercent: -1,
                    posId: -1,
                    taxName: null
                }
            } else {
                taxBand = {
                    id: taxBand.id,
                    taxPercent: taxBand.taxPercent,
                    posId: taxBand.posId,
                    taxName: taxBand.taxName
                }
            }
            taxBands[i] = taxBand;
        }
        return taxBands;
    }

    copyTaxBandsPixelPoint() {
        const { taxSettings } = this.props;
        const taxBands = [];
        for (let i = 0; i < 5; i++) {
            let taxBand = taxSettings.taxBands[i];
            if (taxBand === undefined || taxBand === null || taxBand.taxPercent === null || taxBand.taxPercent < 0) {
                taxBand = {
                    id: (-1 * i),
                    taxPercent: -1,
                    posId: -1,
                    taxName: null
                }
            } else {
                taxBand = {
                    id: taxBand.id,
                    taxPercent: taxBand.taxPercent,
                    posId: taxBand.posId,
                    taxName: taxBand.taxName
                }
            }
            taxBands[i] = taxBand;
        }

        return taxBands;
    }

    changeTaxBandsState({ target }) {
        const updatedTaxBandId = convertStringToNumber(target.id);
        let targetValue = target.value;

        if (targetValue.includes(',')) {
            targetValue.replace('.');
        }

        const updatedTaxBandValue = convertStringToNumber(targetValue);
        const updatedTaxBands = [];

        this.state.taxSettings.taxBands.map(taxBand => {
            if (updatedTaxBandId === taxBand.id) {
                const updatedTaxBand = {
                    id: taxBand.id,
                    taxPercent: updatedTaxBandValue,
                    posId: taxBand.posId
                }
                updatedTaxBands.push(updatedTaxBand);
            } else {
                updatedTaxBands.push(taxBand);
            }
        });

        this.setState({
            taxSettings: {
                ...this.state.taxSettings,
                taxBands: updatedTaxBands
            }
        });
    }

    changeTaxBandsName({ target }, index) {
        let taxBandsCopy = [...this.state.taxSettings.taxBands];
        let currTaxCopy = { ...taxBandsCopy[index] };
        currTaxCopy.taxName = target.value;
        taxBandsCopy[index] = currTaxCopy;

        this.setState({
            ...this.state,
            taxSettings: {
                ...this.state.taxSettings,
                taxBands: taxBandsCopy
            }
        });
    }

    changeConditionalAttributeState({ target }) {
        const checked = convertStringToBoolean(target.checked);

        this.setState({
            taxSettings: {
                ...this.state.taxSettings,
                [target.name]: checked
            }
        });
    }

    saveTaxSettings() {
        const { id } = this.props.match.params;
        let taxBands = JSON.parse(JSON.stringify(this.state.taxSettings.taxBands));
        // Send the data for tax settings in special format when the pos is pixel point
        const posIsPixelPoint = (this.props.posSettings.type && this.props.posSettings.type.id === 5) && this.props.posSettings.type.value === "Par Pixelpoint";
        if (posIsPixelPoint) taxBands = this.formatTaxSettingsForPixelPoint(taxBands);

        this.state.taxSettings.taxBands = JSON.parse(JSON.stringify(taxBands));
        // Call different saveTaxSettings service for pixelPoint and other posses
        (posIsPixelPoint) ? this.props.saveTaxSettingsPixelPoint(id, this.state.taxSettings) : this.props.saveTaxSettings(id, this.state.taxSettings);
    }

    formatTaxSettingsForPixelPoint(taxBands) {
        const creatingNewTaxBands = this.props.taxSettings.taxBands.length === 0;
        let formattedTaxBands = JSON.parse(JSON.stringify(taxBands));

        // When creating new tax band settings send only the value of the tax field -> remove id and posId values
        // When we edit tax bands settings do NOT remove the id and posId values
        if (creatingNewTaxBands) {
            let formattedBands = [];

            formattedTaxBands.map((taxBand) => {
                let formattedTax = {
                    taxPercent: taxBand.taxPercent
                };

                formattedBands.push(formattedTax)
            });

            formattedTaxBands = JSON.parse(JSON.stringify(formattedBands));
        }

        return formattedTaxBands;
    }

    renderHeader() {
        const { headerStyle, spaceBetween } = styles;

        return (
            <div style={headerStyle}>
                <MaterialIcon icon="menu" color="#0288d1" size={20} />
                <span style={spaceBetween}>{i18n.t('screens:taxSettingsScreen.header')}</span>
            </div>
        );
    }

    renderTaxBands() {
        const { bandsTableStyle, bandsTableInnerStyle, underlineTextStyle } = styles;
        const { restaurant, posSettings } = this.props;
        const { taxBands } = this.state.taxSettings;
        const posIsPixelPoint = (posSettings.type && posSettings.type.id === 5) && posSettings.type.value === "Par Pixelpoint";
        let taxBandsColumns = this.renderTaxBandsColumns();
        const restCountry = restaurant.id && restaurant.id !== -1 ? restaurant.address.country : '';
        const showTaxName = restCountry === US || restCountry === CA;

        return (
            <Row style={{ marginLeft: 15 }}>
                <Col xs={7} style={bandsTableStyle}>
                    <Table responsive style={bandsTableInnerStyle}>
                        <thead>
                            <tr>
                                <th style={{ paddingBottom: 0 }}>{this.renderTaxNameInput(showTaxName, taxBands[0], 0, i18n.t('screens:taxSettingsScreen.rate1'))}</th>
                                <th style={{ paddingBottom: 0 }}>{this.renderTaxNameInput(showTaxName, taxBands[1], 1, i18n.t('screens:taxSettingsScreen.rate2'))}</th>
                                <th style={{ paddingBottom: 0 }}>{this.renderTaxNameInput(showTaxName, taxBands[2], 2, i18n.t('screens:taxSettingsScreen.rate3'))}</th>
                                <th style={{ paddingBottom: 0 }}>{this.renderTaxNameInput(showTaxName, taxBands[3], 3, i18n.t('screens:taxSettingsScreen.rate4'))}</th>
                                {posIsPixelPoint ? <th style={{ paddingBottom: 0 }}>{this.renderTaxNameInput(showTaxName, taxBands[4], 4, i18n.t('screens:taxSettingsScreen.rate5'))}</th> : null}
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                {taxBandsColumns}
                            </tr>
                        </tbody>
                    </Table>
                    <div style={underlineTextStyle}>{i18n.t('screens:taxSettingsScreen.defaultRateExplanation')}</div>
                    <div style={underlineTextStyle}>{i18n.t('screens:taxSettingsScreen.posTaxesExplanation')}</div>
                    <div style={underlineTextStyle}>{i18n.t('screens:taxSettingsScreen.taxThirdMsg')}</div>
                </Col>
            </Row>
        );
    }

    renderTaxNameInput(showTaxName, taxBand, taxBandIndex, fallBackText) {
        if (!showTaxName) {
            if (!taxBand.taxName) {
                return fallBackText;
            } else {
                return taxBand.taxName;
            }
        }

        return (
            <InputGroup style={{ maxWidth: 110 }}>
                <Input
                    type="text" lang="en" name={taxBand.id} id={taxBand.id}
                    value={taxBand.taxName ? taxBand.taxName : fallBackText} onChange={(target) => this.changeTaxBandsName(target, taxBandIndex)} />
            </InputGroup>
        );
    }

    renderTaxBandsColumns() {
        const { taxBands } = this.state.taxSettings;
        const posIsPixelPoint = (this.props.posSettings.type && this.props.posSettings.type.id === 5) && this.props.posSettings.type.value === "Par Pixelpoint";

        let readOnly = false;

        return taxBands.map((taxBand, index) => {
            let taxPercent;
            if (taxBand.taxPercent >= 0) {
                taxPercent = taxBand.taxPercent;
            }

            // In this case tax bands are comming from the POS
            // so make them read only in the front-end.

            // For now always keep this as read only until we have a POS
            // where we might need to configure this manually and we will have to
            // check against the POS type to decide if taxes are read only or not.
            readOnly = true;
            if (posIsPixelPoint) readOnly = false;

            return (
                <td key={index}>
                    <InputGroup>
                        <Input type="number" lang="en" name={taxBand.id} id={taxBand.id} readOnly={readOnly}
                            min={0} value={taxPercent} onChange={this.changeTaxBandsState} onKeyPress={(e) => this.negativeDecimalsValidation(e)} />
                        <InputGroupAddon addonType="append">%</InputGroupAddon>
                    </InputGroup>
                </td>
            );
        });
    }

    negativeDecimalsValidation(e) {
        var inputKeyCode = e.keyCode ? e.keyCode : e.which;

        if (inputKeyCode != null) {
            if (inputKeyCode == 43 || inputKeyCode == 45 || inputKeyCode == 69 //|| inputKeyCode == 44
                || inputKeyCode == 101) e.preventDefault();
        }
    }

    renderEmptyTaxBandsColumns() {
        return null;
    }

    renderDivider() {
        const { dividerStyle } = styles;

        return (
            <Row>
                <Col xs={7} style={dividerStyle}>
                </Col>
            </Row>
        );
    }

    renderConditionalAttributes() {
        const { columnGroup, alignChildren, checkboxInput } = styles;
        const { taxIncludedInPrice, taxPostDiscount, taxableDeliveryCharge } = this.state.taxSettings;

        return (
            <Row style={{ marginLeft: 15 }}>
                <Col xs={9} style={columnGroup}>
                    <InputGroup xs={2} style={alignChildren}>
                        <Label for="taxIncludedInPrice">{i18n.t('screens:taxSettingsScreen.taxIncludedInPrice')}</Label>
                        <Input style={checkboxInput} type="checkbox" name="taxIncludedInPrice" id="taxIncludedInPrice"
                            checked={taxIncludedInPrice} onChange={this.changeConditionalAttributeState} />
                    </InputGroup>
                    {/* <InputGroup xs={2} style={alignChildren}>
                        <Label for="taxPostDiscount">{i18n.t('screens:taxSettingsScreen.taxPostDiscount')}</Label>
                        <Input style={checkboxInput} type="checkbox" name="taxPostDiscount" id="taxPostDiscount"
                            checked={taxPostDiscount} onChange={this.changeConditionalAttributeState} />
                    </InputGroup>
                    <InputGroup xs={4} style={alignChildren}>
                        <Label for="taxableDeliveryCharge">{i18n.t('screens:taxSettingsScreen.taxableDeliveryCharge')}</Label>
                        <Input style={checkboxInput} type="checkbox" name="taxableDeliveryCharge" id="taxableDeliveryCharge"
                            checked={taxableDeliveryCharge} onChange={this.changeConditionalAttributeState} />
                    </InputGroup> */}
                </Col>
            </Row>
        );
    }

    renderSaveButton() {
        const { saveButton, spaceBetween } = styles;

        return (
            <Button color="primary" xs={9} style={saveButton} onClick={this.saveTaxSettings}>
                <MaterialIcon icon="save" color="#fff" size={18} /><span style={spaceBetween}>{i18n.t('common:buttons.save')}</span>
            </Button>
        );
    }

    renderNoPosEmptyFields() {
        const { bandsTableStyle, bandsTableInnerStyle, underlineTextStyle } = styles;

        return (
            <Row style={{ marginLeft: 15 }}>
                <Col xs={7} style={bandsTableStyle}>
                    <Table responsive style={bandsTableInnerStyle}>
                        <thead>
                            <tr>
                                <th style={{ paddingBottom: 0 }}>{this.renderTaxNameInput(false, '', 0, i18n.t('screens:taxSettingsScreen.rate1'))}</th>
                                <th style={{ paddingBottom: 0 }}>{this.renderTaxNameInput(false, '', 1, i18n.t('screens:taxSettingsScreen.rate2'))}</th>
                                <th style={{ paddingBottom: 0 }}>{this.renderTaxNameInput(false, '', 2, i18n.t('screens:taxSettingsScreen.rate3'))}</th>
                                <th style={{ paddingBottom: 0 }}>{this.renderTaxNameInput(false, '', 3, i18n.t('screens:taxSettingsScreen.rate4'))}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                {this.renderTaxBandsColumnsNoPos()}
                            </tr>
                        </tbody>
                    </Table>
                    <div style={underlineTextStyle}>{i18n.t('screens:taxSettingsScreen.defaultRateExplanation')}</div>
                    <div style={underlineTextStyle}>{i18n.t('screens:taxSettingsScreen.posTaxesExplanation')}</div>
                    <div style={underlineTextStyle}>{i18n.t('screens:taxSettingsScreen.taxThirdMsg')}</div>
                </Col>
            </Row>
        );
    }

    renderTaxBandsColumnsNoPos() {
        const taxBands = ['', '', '', ''];

        let readOnly = true;

        return taxBands.map((taxBand, index) => {
            return (
                <td key={index}>
                    <InputGroup>
                        <Input type="number" readOnly={readOnly}
                            value={taxBand} />
                        <InputGroupAddon addonType="append">%</InputGroupAddon>
                    </InputGroup>
                </td>
            );
        });
    }

    render() {
        const { containerStyle } = styles;
        this.copyStateFromProps();

        // If taxBands is not mapped to state yet
        const { taxBands } = this.state.taxSettings;
        if (taxBands.length === 0) {
            return (
                <Container fluid style={containerStyle}>
                    <Row>{this.renderHeader()}</Row>
                    <div>
                        {this.renderNoPosEmptyFields()}
                        {this.renderDivider()}
                        {this.renderConditionalAttributes()}
                    </div>
                </Container>
            );
        }

        return (
            <Container fluid style={containerStyle}>
                <Row>{this.renderHeader()}</Row>
                <div>
                    {this.renderTaxBands()}
                    {this.renderDivider()}
                    {this.renderConditionalAttributes()}
                    {this.renderSaveButton()}
                </div>
            </Container>
        );
    }
}

const mapStateToProps = state => {
    return {
        restaurant: state.restaurant,
        posSettings: state.posSettings,
        taxSettings: state.taxSettings
    };
};

export default connect(mapStateToProps, { loadRestaurantSettings, loadTaxSettings, saveTaxSettings, saveTaxSettingsPixelPoint })(TaxesScreen);

const styles = {
    containerStyle: {
        paddingBottom: 10,
        marginLeft: 15,
        marginBottom: 25,
        backgroundColor: '#fafafa',
        borderLeft: '1px solid #0288d1',
        paddingTop: 10,
        height: 365
    },
    spaceBetween: {
        paddingLeft: 4
    },
    headerStyle: {
        display: 'flex',
        borderBottom: '1px solid rgb(222, 226, 230)',
        marginBottom: 20,
        marginLeft: 15,
        paddingLeft: 0,
        color: '#0288d1',
        width: 299
    },
    bandsTableStyle: {
        paddingLeft: 0,
        paddingRight: 0,
        marginTop: 10
    },
    bandsTableInnerStyle: {
        marginBottom: 0
    },
    underlineTextStyle: {
        marginBottom: 10,
        paddingLeft: 10,
        color: '#737373',
        fontSize: '80%',
        fontWeight: 400
    },
    dividerStyle: {
        width: 496,
        marginBottom: 20,
        borderBottom: "1px solid #dee2e6"
    },
    columnGroup: {
        display: 'flex',
        justifyContent: "space-between",
        paddingLeft: 0
    },
    alignChildren: {
        display: "flex"
    },
    checkboxInput: {
        position: "relative",
        marginLeft: 20
    },
    saveButton: {
        float: 'right',
        marginRight: -15,
        marginTop: 30,
        marginBottom: 10
    }
};


// WEBPACK FOOTER //
// ./src/components/restaurants/settings/restaurant/TaxesScreen.js